import e from "dayjs";
// src/design/forms/datepicker/calendar-engine/use-cases/english_date/validate_date_in_range.ts
var t = /^\d{4}-\d{2}-\d{2}$/, n = (n, r, i) => {
	let a = t.test(n);
	return r && (a &&= e(n).isAfter(e(r))), i && (a &&= e(n).isBefore(e(i))), a;
};
export { t as dateFormat, n as validate_date_in_range };

//# sourceMappingURL=validate_date_in_range.js.map